// types
import type { PurchaseHistoryRate } from '@makemydeal/dr-dash-types';
import { PURCHASE_HISTORY_PLACEHOLDER } from '@makemydeal/dr-dash-types';

export const composeTermDisplay = (termMonths: string, remainingPayments: number | null): string => {
    if (termMonths === PURCHASE_HISTORY_PLACEHOLDER) {
        return termMonths;
    }

    if (remainingPayments == null) {
        return termMonths;
    }

    return remainingPayments === 0 ? `${termMonths} (paid off)` : `${termMonths} (${remainingPayments} remaining)`;
};

/** The two sides of the rate row, in the order the label reads. */
export const composeRateDisplay = ({ buyRate, sellRate }: PurchaseHistoryRate): string => `${buyRate} / ${sellRate}`;
